import './App.css';
import './style.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import ReactGA from 'react-ga4';
import { MainPage } from './MainPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import { isBotFoundAtom } from './atoms/general';
// import { setCSSVariables } from './colors.js'

const App = () => {
  const [isBotFound] = useAtom(isBotFoundAtom);

  useEffect(() => {
    // Track app entry
    ReactGA.event({
      category: 'User',
      action: 'App Entry',
      label: window.location.href,
    });

    const setProperties = async () => {
      // await setCSSVariables()
    };
    setProperties();
  }, []);

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={isBotFound ? <MainPage /> : <NotFoundPage />} />
          <Route path="/:botId" element={isBotFound ? <MainPage /> : <NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
